import { useContext } from 'react';
import { ApiSettingsContext } from './apiSettingsContext';

export function useApiSettings() {
  return useContext(ApiSettingsContext);
}
